import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { UserSessionService } from '@core/services/user-session.service';

/**
 * Prevents access to AI Agents if onboarding has not been completed.
 * Redirects to /onboarding if user hasn't finished onboarding.
 */
export const onboardingCompletedGuard: CanActivateFn = () => {
    const userSession = inject(UserSessionService);
    const router = inject(Router);

    if (userSession.isOnboardingCompleted() && userSession.hasSession()) {
        return true;
    }

    return router.createUrlTree(['/onboarding/setup']);
};
